module.exports = __webpack_public_path__ + "static/media/КАшникова А. (MM).6324ea87.pdf";